export default __webpack_public_path__ + "static/media/Asset 21.82baeb84.png";